import {makeAutoObservable, observable, runInAction} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {RequestState} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {IPlayersStore} from "data/stores/players/players.store";
import type {ITournamentsStore} from "data/stores/tournaments/tournaments.store";
import type {ISegmentsStore} from "data/stores/segments/segments.store";
import type {ICountryStore} from "data/stores/country/country.store";

export interface IEntryPointsController extends ViewController {
	get isLoaded(): boolean;
}

@injectable()
export class EntryPointsController implements IEntryPointsController {
	@observable _requestState: RequestState = RequestState.IDLE;

	get isLoaded() {
		return [RequestState.SUCCESS, RequestState.ERROR].includes(this._requestState);
	}

	constructor(
		@inject(Bindings.SegmentsStore) private _segmentsStore: ISegmentsStore,
		@inject(Bindings.PlayersStore) private _playersStore: IPlayersStore,
		@inject(Bindings.TournamentsStore) private _tournamentsStore: ITournamentsStore,
		@inject(Bindings.CountryStore) private _countryStore: ICountryStore
	) {
		makeAutoObservable(this);
	}

	async init() {
		this._requestState = RequestState.PENDING;

		await Promise.all([
			this._segmentsStore.fetchSegments(),
			this._tournamentsStore.fetchTournaments(),
			this._playersStore.fetchPlayers(),
			this._countryStore.requestCountry(),
		])
			.then(() =>
				runInAction(() => {
					this._requestState = RequestState.SUCCESS;
				})
			)
			.catch(() =>
				runInAction(() => {
					this._requestState = RequestState.ERROR;
				})
			);
	}
}
